module.exports = __webpack_public_path__ + "img/undraw_into_the_night_vumi.588689a0.svg";